/* ABR gallery enhancement. Links and horizontal browsing also work without JavaScript. */
if (!customElements.get('abr-gallery')) {
  customElements.define('abr-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('.abr-gallery__track');
      this.slides = [...this.querySelectorAll('[data-abr-photo]')];
      this.thumbs = [...this.querySelectorAll('[data-abr-thumb]')];
      this.dialog = this.querySelector('dialog');
      this.caption = this.querySelector('[data-abr-caption]');
      if (!this.track || !this.dialog) return;
      this.thumbs.forEach((button, index) => button.addEventListener('click', () => this.goTo(index), {signal}));
      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.goTo(Math.max(0, Math.min(this.slides.length - 1, (this.current || 0) + (event.key === 'ArrowRight' ? 1 : -1))));
      }, {signal});
      let timer;
      this.track.addEventListener('scroll', () => {
        clearTimeout(timer);
        timer = setTimeout(() => this.update(Math.round(this.track.scrollLeft / this.track.clientWidth)), 70);
      }, {passive:true, signal});
      this.slides.forEach(slide => slide.addEventListener('click', event => {
        if (!this.dialog.showModal) return;
        event.preventDefault();
        const img = this.dialog.querySelector('[data-abr-enlarged]');
        img.src = slide.href;
        img.alt = slide.querySelector('img').alt;
        this.dialog.querySelector('[data-abr-lightbox-caption]').textContent = slide.dataset.caption;
        this.dialog.showModal();
      }, {signal}));
      this.dialog.querySelector('[data-abr-close]').addEventListener('click', () => this.dialog.close(), {signal});
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, {signal});
      this.update(0);
    }
    goTo(index) {
      const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      this.track.scrollTo({left: index * this.track.clientWidth, behavior});
      this.update(index);
    }
    update(index) {
      this.current = index;
      this.thumbs.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      if (this.slides[index]) this.caption.textContent = this.slides[index].dataset.caption;
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
(() => {
  const openSizeGuide = () => {
    if (window.location.hash !== '#ABR-SizeGuide') return;
    const guide = document.getElementById('ABR-SizeGuide');
    if (guide instanceof HTMLDetailsElement) guide.open = true;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openSizeGuide, {once: true});
  else openSizeGuide();
  window.addEventListener('hashchange', openSizeGuide);
})();
